import React from 'react';
import { Button } from './ui/button';
import { Send } from 'lucide-react';
import { siteContent } from '../mockData';
import { useTranslation } from 'react-i18next';

const MediaCoverage = () => {
  const { contact } = siteContent;
  const { t } = useTranslation();

  const handleTelegram = () => {
    window.open(contact.telegram, '_blank');
  };

  return (
    <section data-testid="media-coverage-section" className="py-24 relative overflow-hidden">
      {/* Gradient Background */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#0D1F40] via-[#0A1628] to-[#0D1F40]"></div>
      
      {/* Animated Overlay */}
      <div className="absolute inset-0 opacity-20" style={{
        backgroundImage: `radial-gradient(circle at 20% 50%, rgba(0, 212, 255, 0.3) 0%, transparent 50%),
                         radial-gradient(circle at 80% 50%, rgba(0, 229, 160, 0.3) 0%, transparent 50%)`
      }}></div>

      <div className="container mx-auto px-4 lg:px-8 relative z-10">
        <div className="max-w-5xl mx-auto text-center">
          <h2 data-testid="media-coverage-title" className="text-4xl md:text-5xl font-bold text-[#F5C518] mb-8 leading-tight">
            {t('mediaCoverage.title')}
          </h2>
          <p data-testid="media-coverage-desc" className="max-w-4xl !text-xl mb-12 mx-auto text-white">
            {t('mediaCoverage.desc')}
          </p>
          <Button
            data-testid="media-coverage-telegram-btn"
            onClick={handleTelegram}
            className="bg-[#F5C518] hover:bg-[#00E5A0] text-black font-bold px-8 py-6 text-lg rounded-md transition-all duration-200 hover:scale-105 shadow-lg shadow-[#F5C518]/30 hover:shadow-[#00E5A0]/40 flex items-center gap-2 mx-auto">
            <Send size={20} />
            {t('hero.telegram')}
          </Button>
        </div>
      </div>
    </section>);

};

export default MediaCoverage;